exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".privacySettingsFooter---32UD5{display:-webkit-box;display:-moz-flex;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;-moz-align-items:center;align-items:center;-webkit-box-pack:end;-ms-flex-pack:end;-moz-justify-content:flex-end;justify-content:flex-end;position:fixed;bottom:.1px;left:.1px;width:100%;height:77px;padding-right:10px;background-color:#adb6bc}.privacySettingsFooter---32UD5 .cancelButton---1wcEv,.privacySettingsFooter---32UD5 .saveButton---2WcZ3{width:115px;height:45px;border-radius:22px;margin:10px;padding-top:14px;color:#fff;background-color:#415667;font-family:Poppins;font-size:16px;line-height:20px}.privacySettingsFooter---32UD5 .saveButton---2WcZ3{width:95px}", ""]);

// exports
exports.locals = {
	"privacySettingsFooter": "privacySettingsFooter---32UD5",
	"cancelButton": "cancelButton---1wcEv",
	"saveButton": "saveButton---2WcZ3"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader/dist/cjs.js?{"implementation":{"info":"dart-sass/t1.26.11/t(Sass Compiler)/t[Dart]/ndart2js/t2.9.3/t(Dart Compiler)/t[Dart]","types":{},"NULL":{},"TRUE":{"value":true},"FALSE":{"value":false}},"includePaths":["/usr/src/app/node_modules"]}!./app/components/privacy-settings/sub-components/privacy-settings-footer/index.scss
// module id = 726
// module chunks = 3